import { useMutation, useQueryClient } from "react-query";
import React from "react";
import * as wf from "@qpr/client-api-workflow";
import * as types from "@qpr/client-api-workflow/types";
import { clearElementCache } from "@qpr/client-api-base/querybuilder/ElementCache";
import { clear } from "console";

const useStartElementWorkflow = () => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  return useMutation(async (data: { period: string; elementIds: string[] }) => {
    const list = await wf.createWFTestIntances({
      clearPrevious: "false",
      configName: "value approval",
      period: data.period,
      query: `[${data.elementIds.join(",")}]`,
    });
    clearElementCache(data.elementIds || []);
    console.log("createWFTestIntances ", list);
  }, invalidateCache);
};

export default useStartElementWorkflow;
